import { Tooltip, Chip } from "@mui/joy";

export type ConflictLikelihood = "high" | "medium" | "low";

const config: Record<
    ConflictLikelihood,
    {
        color: "danger" | "warning" | "neutral";
        defaultLabel: string;
        tooltip: string;
    }
> = {
    high: {
        color: "danger",
        defaultLabel: "high",
        tooltip: "Marvin thinks that this is a very likely conflict that might result in an RFI.",
    },
    medium: {
        color: "warning",
        defaultLabel: "medium",
        tooltip: "Marvin thinks there might be a conflict here but it’s not very sure.",
    },
    low: {
        color: "neutral",
        defaultLabel: "low",
        tooltip: "Marvin doesn’t think that this is a conflict but it might be worth checking.",
    },
};

interface ConflictLikelihoodChipProps {
    sev: ConflictLikelihood;
    label?: string;
}

export const ConflictLikelihoodChip = ({ sev, label }: ConflictLikelihoodChipProps) => {
    const { color, defaultLabel, tooltip } = config[sev];

    return (
        <Tooltip variant="soft" title={tooltip} placement="left">
            <Chip variant="soft" size="sm" color={color} sx={{ textTransform: "uppercase" }}>
                {label ?? defaultLabel}
            </Chip>
        </Tooltip>
    );
};
